import Billing from "./Billing";

export default Billing;